module.exports = __webpack_public_path__ + "static/media/question-mark-circle-white.bc1ca026.svg";